import {
  SET_CURRENT_USER,
  VERIFY_USER,
  RESET_LOCALSTORAGE_USER,
  RESET_PASSWORD,
  RESET_SHOW_RESET_PASSWORD,
  PASSWORD_UPDATED,
  RESEND_VERIFICATION,
  SHOW_SPINNER,
  RESET_SPINNER,
  REGISTRATION_SUCCESSFUL,
  RESET_SIGNUP,
} from '../actions/types';
import isEmpty from '../is-empty';

const initialState = {
  isAuthenticated: false,
  user: {} as any,
  verified: null as boolean | null,
  verifyloading: false,
  checkUser: {
    userName: null as string | null,
    logInTime: null as number | null,
  },
  showResetPasswordSuccess: false,
  passwordUpdated: false,
  resendLink: false,
  spinner: false,
  showRegistrationSuccess: false,
};

function reducer(state = initialState, action: { type: string; payload?: any }) {
  switch (action.type) {
    case RESET_SIGNUP:
      return {
        ...state,
        showRegistrationSuccess: false,
      };
    case REGISTRATION_SUCCESSFUL:
      return {
        ...state,
        showRegistrationSuccess: true,
      };
    case RESEND_VERIFICATION:
      return {
        ...state,
        resendLink: true,
      };
    case PASSWORD_UPDATED:
      return {
        ...state,
        passwordUpdated: true,
      };
    case RESET_SHOW_RESET_PASSWORD:
      return {
        ...state,
        showResetPasswordSuccess: false,
      };
    case RESET_PASSWORD:
      return {
        ...state,
        showResetPasswordSuccess: true,
      };
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty(action.payload),
        user: action.payload,
        checkUser: {
          userName: action.payload.firstName,
          logInTime: Date.now(),
        },
        spinner: false,
      };

    case VERIFY_USER:
      return {
        ...state,
        verified: action.payload,
      };
    case RESET_LOCALSTORAGE_USER:
      return {
        ...state,
        checkUser: {
          userName: null,
          logInTime: null,
        },
      };

    case SHOW_SPINNER:
      return {
        ...state,
        spinner: true,
      };
    case RESET_SPINNER:
      return {
        ...state,
        spinner: false,
      };

    default:
      return state;
  }
}

export default reducer;
